var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shown)?_c('div',{staticClass:"text-zt-danger"},_vm._l((_vm.messages),function(message,i){return _c('span',{key:i,staticClass:"text-zt-xs"},[_vm._v("\n    "+_vm._s(message)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }